// src/pages/auth/HospitalityLogin.jsx
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { getTranslation } from "../../utils/translations";

export default function HospitalityLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();
  const { lang } = useContext(LanguageContext);
  const t = getTranslation(lang);

  // ------------------- HANDLE SUBMIT -------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      return alert(t.hospitality_login?.enter_credentials);
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok)
        return alert(data.message || t.hospitality_login?.login_failed); // shows real backend error

      // Save token and user info
      // Save token and user info
      localStorage.setItem("token", data.token);

      // Ensure admin is a proper boolean (true if 't', false if 'f')
      const userWithBool = {
        ...data.user,
        admin: data.user.admin === true || data.user.admin === "t",
      };
      localStorage.setItem("user", JSON.stringify(userWithBool));

      login(data.token);

      // Redirect to Hospitality Home
      navigate("/");
    } catch (err) {
      console.error("Login error:", err);
      alert(err.message || t.hospitality_login?.unexpected_error); // shows actual JS/network error
    }
  };

  // ------------------- JSX -------------------
  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>{t.hospitality_login?.title}</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder={t.hospitality_login?.business_email}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={inputStyle}
        />
        <input
          type="password"
          placeholder={t.hospitality_login?.password}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={inputStyle}
        />
        <button type="submit" style={buttonStyle}>{t.hospitality_login?.login}</button>
      </form>

      <p style={footerTextStyle}>
        {t.hospitality_login?.no_account}{" "}
        <Link to="/register" style={linkStyle}>{t.hospitality_login?.register_here}</Link>
      </p>
    </div>
  );
}

// ------------------- STYLES -------------------
const containerStyle = {
  maxWidth: "420px",
  margin: "60px auto",
  padding: "30px",
  borderRadius: "12px",
  border: "1px solid #ddd",
  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  backgroundColor: "#fff",
};

const titleStyle = {
  textAlign: "center",
  marginBottom: "25px",
  color: "#f97316",
  fontSize: "1.8rem",
  fontWeight: "600",
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "15px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "16px",
  outline: "none",
};

const buttonStyle = {
  width: "100%",
  padding: "12px",
  backgroundColor: "#f97316",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: "500",
  transition: "background 0.3s",
};

const footerTextStyle = {
  marginTop: "15px",
  textAlign: "center",
  fontSize: "14px",
  color: "#333",
};

const linkStyle = {
  color: "#f97316",
  textDecoration: "none",
  fontWeight: "500",
};
